<h1 class="page-title w-50"> قطاع الصناعات الدوائية و الطبية
</h1>
<div class="pb-5">
  <div class="d-flex justify-content-between">
    <div class="share-section mb-4 w-50 pt-5">
      <div class="share-text mb-2">شارك المقال على</div>
      <div class="social-icons d-flex justify-content-end gap-2">
        <a href="#" class="social-icon">
          <i class="fa-brands fa-twitter"></i>
        </a>
        <a href="#" class="social-icon">
          <i class="fa-brands fa-facebook-f"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="banner-container">
      <img src="../../../assets/Pharmaceuticals-banner.jpg" alt=" " class="banner-image" />
      <div class="growth-badge">
        <span>مصر تنتج المزيد من الأطباء والصيادلة اكثر من أي بلد آخر في الشرق الأوسط. </span>
      </div>
    </div>

    <div class="sector-content">
      <p>قطاع الصناعات الدوائية و الطبية
      </p>
      <hr />
      <p> عن قطاع الصناعات الدوائية و الطبية
        : </p>
      <p>
        تمتلك مصر الكثير من المزايا المتأصلة الممثلة في عبقرية موقعها الاستراتيجي بين دول العالم، والإرث الثقافي العريق،
        والتعداد السكاني الكبير والمتنامي، هذا بالإضافة إلى ان قطاع الصناعات الدوائية قيد التطور مما يتيح فرص كبيرة
        للتوسع والاستثمار الأجنبي بالإضافة الي الاستثمار المحلي.يعد قطاع الصناعات الدوائية واحدًا من أقدم القطاعات
        الاستراتيجية في مصر حيث ظهر عام 1939 مع تأسيس شركة مصر للمستحضرات الطبية (هولدي فارما).[1] التي كانت تعتبر أول
        منشأة وطنية في ذلك الوقت.وقد اعطت مصر اهتمامًا كبيرًا لأولوية تحقيق الاكتفاء الذاتي من الدواء، كما تبنت سياسات
        تستهدف تطوير الأدوية في مراحل الصناعة المختلفة، وذلك على مستوى المواد الخام المستعملة في المستحضرات الطبية
        والكيماويات الأساسية والتصنيع والتعبئة وكذلك التسويق والبيع والتصدير.في هذا التقرير، سيتم تسليط الضوء على بعض
        الخصائص الرئيسية لسوق الصناعات الدوائية المصري، بالإضافة إلى نظرة عامة على مؤشرات الأداء الرئيسية، وكذلك بعض قصص
        النجاح في قطاع الصناعات الدوائية .[1] شركة هولدي فارما​​.

      </p>
      <a href="https://www.investinegypt.gov.eg/Arabic/Pages/exploreMap.aspx?secId=96">لمزيد من المعلومات اضغط هنا</a>
    </div>
  </div>
</div>